import React from 'react';
import autoBind from 'react-autobind';
import Switch, { Case, Default } from 'react-switch-case';

import Config from "composer/Config.jsx";
import Localization from "composer/Localization.jsx"
import SubmissionDetailContent from "composer/views/retriever/SubmissionDetailContent.jsx"

import {
  Icon,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
  Tooltip,
  IconButton,
} from '@material-ui/core';

class SubmissionDetailAnswer extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      answerData: this.props.answerData,
      componentData: this.props.componentData,
    };
    autoBind(this);
  }

  compareAnswerClicked() {
    this.props.parent.props.parent.getAllAnswers(this.state.answerData, this.state.componentData);
  }

  fillInTheBlank(kind) {
    if (kind != Config.HOTSPOT_CONTENT_FILL_IN_THE_BLANK) {
      return;
    }
    
    let payload = '';
    try{
      payload = JSON.parse(this.state.componentData.payload.replace(/[\n\r]/g, ''));
    }
    catch(err){
      // console.log('the following payload causes the error:');
      // for (let i = 0; i < this.state.componentData.payload.length; i++) {
      //   console.log(i.toString()+': '+this.state.componentData.payload[i].charCodeAt(0)+this.state.componentData.payload[i]);
      // }
      console.log(err);
    }
    // let payload = JSON.parse(this.state.componentData.payload);
    // let payload = JSON.parse('{"text2":"","picture0":{"ok":1,"file_type":"jpg","message":"CC_qu qiao.jpg uploaded successfully.","file_id":163371,"path":"2017-3-29/1490800815___9wn3im2924cafjph.jpg","file_size":190819,"tmp_name":"/tmp/php8fenVX","move_file_result":true,"tn_path":"2017-3-29/s_1490800815___9wn3im2924cafjph.jpg","display_name":"CC_qu qiao"},"text1":"拱橋：人生道路有（1），安步能通彼岸。曲橋：人生道路有（2），徐行可達彼岸。"}');
    let textBefore = (payload.text1 != null? payload.text1 : "");
    let textAfter = (payload.text2 != null? payload.text2 : "");
    return (
        textBefore + " ( ... ) " + textAfter
    );
  }

  render() {
    let kind = parseInt(this.state.answerData.kind);
    let name = (this.state.componentData.name != null? this.state.componentData.name : "");
    let content = (this.state.componentData.content != null? this.state.componentData.content : "");

    if (name == "") {
      name = Config.GET_HOTSPOT_CONTENT_CONFIG(kind).title;
    }

    return (
      <div>
        <ListItem>
          <ListItemIcon>
            <Icon>{Config.GET_HOTSPOT_CONTENT_CONFIG(kind).icon}</Icon>
          </ListItemIcon>

          <Switch condition={kind}>
            <Case value={Config.HOTSPOT_CONTENT_FILL_IN_THE_BLANK}>
              <ListItemText
                primary={name}
                secondary={this.fillInTheBlank(kind)}
              />
            </Case>
            <Default>
              <ListItemText
                primary={name}
                secondary={content}
              />
            </Default>
          </Switch>
          <ListItemSecondaryAction>
            <Tooltip title={Localization.strings.COMPARE_ANSWERS}>
              <IconButton onClick={this.compareAnswerClicked}><Icon>group</Icon></IconButton>
            </Tooltip>
          </ListItemSecondaryAction>
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <Icon></Icon>
          </ListItemIcon>
          <SubmissionDetailContent root={this.props.root} parent={this}
            answerData={this.state.answerData}
            componentData={this.state.componentData}
          />
        </ListItem>
      </div>
    )
  }
}

export default SubmissionDetailAnswer;
